import { ChatMessage as ChatMessageType } from "@/hooks/useChat";
import { ChatMessage } from "./ChatMessage";

interface ChatMessageGroupProps {
  date: string;
  messages: ChatMessageType[];
}

export const ChatMessageGroup = ({ date, messages }: ChatMessageGroupProps) => {
  return (
    <div className="space-y-4">
      <div className="sticky top-0 z-10 flex justify-center">
        <span className="bg-muted px-3 py-1 rounded-full text-sm text-muted-foreground">
          {date}
        </span>
      </div>
      {messages.map((message, index) => (
        <ChatMessage key={index} message={message} />
      ))}
    </div>
  );
};